"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    deleteShape: function() {
        return deleteShape;
    },
    flatAnnotationsArray: function() {
        return flatAnnotationsArray;
    },
    getById: function() {
        return getById;
    },
    getNextAnnotationIndex: function() {
        return getNextAnnotationIndex;
    },
    modify: function() {
        return modify;
    },
    update: function() {
        return update;
    }
});
const _uuid = require("uuid");
const _IRVIEWER = /*#__PURE__*/ _interop_require_default(require("."));
const _coordinates = require("../../Transforms/coordinates.js");
const _enums = require("../../enums");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function flatAnnotationsArray(ANNOTATIONS = {}, getDisplayCoordinates = null) {
    /**
   * Returns:       flat array of annotation objects
   * Return Value:  [{type, id, name, data}, ...]
   * Note:          supports optional ordering
   */ return Object.entries(ANNOTATIONS).flatMap(([type, annotations])=>Object.entries(annotations).map(([id, data])=>({
                id,
                className: "annotation",
                type,
                isVisible: true,
                isStandard: false,
                name: data === null || data === void 0 ? void 0 : data.name,
                label: data === null || data === void 0 ? void 0 : data.label,
                points: (data === null || data === void 0 ? void 0 : data.points).map(getDisplayCoordinates)
            })));
}
function get(imageInfo = {}) {
    const { ANNOTATIONS = {} } = _IRVIEWER.default.get(imageInfo);
    return ANNOTATIONS;
}
function getById(id = "", imageInfo = {}) {
    const ANNOTATIONS = get(imageInfo);
    let response = {};
    // Search for the ID in each marker shape
    try {
        for (const shape of Object.keys(ANNOTATIONS)){
            const marker = ANNOTATIONS[shape][id];
            if (marker) {
                response = {
                    shape,
                    marker
                };
            }
        }
    } catch (error) {
        console.error(`Failed to delete ${id}`, error);
    }
    return response;
}
function getNextAnnotationIndex(type = "", imageInfo = {}) {
    const ANNOTATION = get(imageInfo);
    const markerType = _enums.KonvaToRendererShapes[type];
    var _ANNOTATION_markerType, _Object_keys;
    const keys = (_Object_keys = Object.keys((_ANNOTATION_markerType = ANNOTATION === null || ANNOTATION === void 0 ? void 0 : ANNOTATION[markerType]) !== null && _ANNOTATION_markerType !== void 0 ? _ANNOTATION_markerType : {})) !== null && _Object_keys !== void 0 ? _Object_keys : [];
    const count = Math.max(0, keys.length);
    return `${type}${count}`;
}
function modify(shape, imageInfo = {}) {
    var _ANNOTATIONS_shapeType;
    const { id = "", type = "" } = shape, nextShape = _object_without_properties(shape, [
        "id",
        "type"
    ]);
    // modify ANNOTATIONS object structure
    const ANNOTATIONS = get(imageInfo);
    // get marker shape from shape enum
    const shapeType = _enums.KonvaToRendererShapes[type];
    // update USERDEFINED MARKERS
    const nextANNOTATIONS = _object_spread_props(_object_spread({}, ANNOTATIONS), {
        [shapeType]: _object_spread_props(_object_spread({}, ANNOTATIONS === null || ANNOTATIONS === void 0 ? void 0 : ANNOTATIONS[shapeType]), {
            [id]: _object_spread({}, ANNOTATIONS === null || ANNOTATIONS === void 0 ? void 0 : (_ANNOTATIONS_shapeType = ANNOTATIONS[shapeType]) === null || _ANNOTATIONS_shapeType === void 0 ? void 0 : _ANNOTATIONS_shapeType[id], nextShape)
        })
    });
    return nextANNOTATIONS;
}
function update(shape, imageInfo = {}) {
    // update ANNOTATIONS object with new or modified Annotation
    let { type, id, name, label, points = [] } = shape;
    id = id || (0, _uuid.v4)();
    name = name || getNextAnnotationIndex(type, imageInfo);
    if (type === _enums.KonvaToRendererShapes.Text) {
        points = (0, _coordinates.getBoundingBox)(points);
    }
    // update ANNOTATIONS object
    const nextANNOTATIONS = modify({
        id,
        type,
        name,
        label,
        points
    }, imageInfo);
    // update parent (IRVIEWER) object
    const nextIRVIEWER = _IRVIEWER.default.modify(_enums.IRViewerKeys.ANNOTATIONS, nextANNOTATIONS, imageInfo);
    return [
        id,
        nextIRVIEWER
    ];
}
function deleteShape(shape, imageInfo = {}) {
    const ANNOTATIONS = get(imageInfo);
    const { id = "", type = "" } = shape;
    let nextANNOTATIONS = {};
    if (!id || !type) {
        // invalid id (marker not found)
        console.error(`Annotation ${id} not found with shape ${type}`);
        return ANNOTATIONS;
    }
    nextANNOTATIONS = _object_spread({}, ANNOTATIONS);
    if (nextANNOTATIONS[type]) {
        delete nextANNOTATIONS[type][id];
    } else {
        // Handle the case when USERDEFINED[shape] is not defined
        console.warn(`Invalid Annotation shape: ${type}`);
    }
    // update parent (IRVIEWER) object
    const nextIRVIEWER = _IRVIEWER.default.modify(_enums.IRViewerKeys.ANNOTATIONS, nextANNOTATIONS, imageInfo);
    return nextIRVIEWER;
}
const annotationsHandler = {
    get,
    getById,
    modify,
    update,
    deleteShape
};
const _default = annotationsHandler;
